var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{attrs:{"id":"mainApp"}},[_c('v-main',[_c('v-toast'),_c('router-view')],1)],1),_c('e-modal'),_c('e-modal-dinamic'),_c('e-loader'),_c('e-botao-atendimento-ia')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }